class ProductZoom {
  constructor() {
    this.initialized = false;
    this.init();
  }

  init() {
    // Wait for images to be loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeZoom());
    } else {
      this.initializeZoom();
    }
  }

  initializeZoom() {
    if (this.initialized) return;
    
    // Target the main slider images
    const mainSlider = document.querySelector('.carousel-main');
    if (!mainSlider) {
      console.log('No main slider found, retrying in 1 second...');
      setTimeout(() => this.initializeZoom(), 1000);
      return;
    }

    // Find all main product images in the carousel
    const productImages = mainSlider.querySelectorAll('.product__image');
    if (productImages.length === 0) {
      console.log('No product images found, retrying in 1 second...');
      setTimeout(() => this.initializeZoom(), 1000);
      return;
    }

    productImages.forEach(img => {
      // Skip if already in a zoom container
      if (img.closest('.product-zoom-container')) {
        return;
      }

      // Setup zoom for each main image
      this.setupZoom(img);
    });

    this.initialized = true;

    // Listen for Flickity slide change events
    mainSlider.addEventListener('change.flickity', () => {
      const currentSlide = mainSlider.querySelector('.is-selected');
      if (currentSlide) {
        const img = currentSlide.querySelector('.product__image');
        if (img) {
          img.style.transformOrigin = 'center center';
        }
      }
    });

    // Handle navigation buttons
    const navButtons = mainSlider.querySelectorAll('.flickity-button');
    navButtons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        const currentImg = mainSlider.querySelector('.is-selected .product__image');
        if (currentImg) {
          currentImg.style.transform = 'none';
        }
      });
    });
  }

  setupZoom(img) {
    // Skip if already in a zoom container
    if (img.parentNode.classList.contains('product-zoom-container')) {
      return;
    }

    // Create zoom container
    const container = document.createElement('div');
    container.className = 'product-zoom-container';
    
    // Replace image with container + image
    img.parentNode.insertBefore(container, img);
    container.appendChild(img);
    
    // Add event listeners
    container.addEventListener('mousemove', (e) => this.handleMouseMove(img, e));
    container.addEventListener('mouseleave', () => this.handleMouseLeave(img));
    container.addEventListener('touchstart', (e) => this.handleTouchStart(img, e));
    container.addEventListener('touchmove', (e) => this.handleTouchMove(img, e));
    container.addEventListener('touchend', () => this.handleTouchEnd(img));

    // Handle navigation interaction
    container.addEventListener('mouseenter', () => {
      const slider = img.closest('.carousel-main');
      if (slider) {
        const buttons = slider.querySelectorAll('.flickity-button');
        buttons.forEach(button => button.style.zIndex = '10');
      }
    });

    container.addEventListener('mouseleave', () => {
      const slider = img.closest('.carousel-main');
      if (slider) {
        const buttons = slider.querySelectorAll('.flickity-button');
        buttons.forEach(button => button.style.zIndex = '');
      }
    });
  }

  handleMouseMove(img, e) {
    // Don't zoom if hovering over navigation buttons
    if (e.target.closest('.flickity-button')) {
      return;
    }

    const zoomer = e.currentTarget;
    const rect = zoomer.getBoundingClientRect();
    
    // Calculate mouse position relative to container
    const x = (e.clientX - rect.left) / zoomer.offsetWidth;
    const y = (e.clientY - rect.top) / zoomer.offsetHeight;
    
    // Move the image
    img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  }

  handleMouseLeave(img) {
    img.style.transformOrigin = 'center center';
  }

  // Touch support for mobile devices
  handleTouchStart(img, e) {
    // Don't zoom if touching navigation buttons
    if (e.target.closest('.flickity-button')) {
      return;
    }
    e.preventDefault();
    img.style.transition = 'none';
  }

  handleTouchMove(img, e) {
    // Don't zoom if touching navigation buttons
    if (e.target.closest('.flickity-button')) {
      return;
    }
    e.preventDefault();
    const touch = e.touches[0];
    const zoomer = e.currentTarget;
    const rect = zoomer.getBoundingClientRect();
    
    const x = (touch.clientX - rect.left) / zoomer.offsetWidth;
    const y = (touch.clientY - rect.top) / zoomer.offsetHeight;
    
    img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  }

  handleTouchEnd(img) {
    img.style.transition = 'transform 0.3s ease-out';
    img.style.transformOrigin = 'center center';
  }
}

// Initialize zoom functionality
const productZoom = new ProductZoom(); 